import Konva from "konva";
import React from "react";

import { usePermanent } from "~/tools/use-permanent";

import { Shape, type ShapeConfig } from "./Shape";

export type RectConfig = ShapeConfig;

export type RectProps = RectConfig;

export const Rect: React.FC<RectProps> = (config) => {
	const rect = usePermanent(() => new Konva.Rect(config));

	return <Shape instance={rect} {...config} />;
};
